/* eslint-disable camelcase */
import axios from 'axios';
import {
  EVENTS_ENDPOINT,
  EVENT_TYPES_ENDPOINT,
  EVENTS_LIST_ENDPOINT,
  EVENT_OCCURRENCES_ENDPOINT,
} from '@dynameat/constants';

export const eventTypeListRequest = () => axios.get(EVENT_TYPES_ENDPOINT());
export const createEventTypeRequest = (eventType) => axios.post(EVENT_TYPES_ENDPOINT(), eventType);
export const updateEventTypeRequest = (eventTypeName, eventType) => axios.patch(EVENT_TYPES_ENDPOINT(eventTypeName), eventType);
export const deleteEventTypeRequest = (eventTypeName) => axios.delete(EVENT_TYPES_ENDPOINT(eventTypeName));
export const eventListRequest = () => axios.get(EVENTS_LIST_ENDPOINT());
export const createEventRequest = (event) => axios.post(EVENTS_ENDPOINT(), event);
export const updateEventRequest = (eventGuid, event) => axios.patch(EVENTS_ENDPOINT(eventGuid), event);
export const deleteEventRequest = (eventGuid) => axios.delete(EVENTS_ENDPOINT(eventGuid));

// Event occurrences
export const eventOccurrenceCalendarListRequest = async (cancelToken, customParams = {}) => {
  try {
    return await axios.get(EVENT_OCCURRENCES_ENDPOINT(), {
      params: { page_size: 200, ...customParams }, cancelToken
    });
  } catch (error) {
    if (!axios.isCancel(error)) throw error;
  }
  return undefined;
};
